import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({}));

export default styles;
